// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Sfy","newExpiryDate":"styles_newExpiryDate__1vKBS","footer":"styles_footer__10D85"};